module.exports = __webpack_public_path__ + "img/liucheng.ce31d68d.png";